import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { piIconAdd } from '@predictiveindex/pi-client-icons';
import {
    TapestryButtonModule,
    TapestryIconModule,
    TapestryIconRegistryService,
    TapestryInlineMessageBoxModule
} from '@predictiveindex/tapestry';
import { EditAvatarComponent } from './edit-avatar.component';

const components = [EditAvatarComponent];

@NgModule({
    imports: [
        CommonModule,
        TapestryIconModule,
        TapestryButtonModule,
        TapestryInlineMessageBoxModule
    ],
    declarations: [...components],
    exports: [...components]
})
export class EditAvatarModule {
    constructor(private iconRegistry: TapestryIconRegistryService) {
        iconRegistry.registerIcons([piIconAdd]);
    }
}
